import GeneralSettingsPage from './GeneralSettingsPage';

export default GeneralSettingsPage;
